<template>
  <div class="shopping-card">
    <Steps/>

    <AskForNumber
        v-if="showAskNumber"
        @hideMe="hideAsk"
        @hereisTheNumber="play"
    />
    <b-container>
      <b-row>
        <b-col cols="12" class="product-for-numb">
          <h1 class="h2 text-center">قائمة المشتريات</h1>
          <p>
            عزيزي العميل انت فقط من ترى بياناتك وهي محفوظة لدينا في سرية
            <font icon="lock"/>
          </p>
          <h2 v-if="cart.length < 1" class="text-center" style="color: #aaa">
            قائمة المشتريات فارغة
          </h2>
        </b-col>

        <b-col cols="12" v-for="(i, index) in cart" :key="index">
          <SingleCartItem :itemInfo="i"/>
        </b-col>

        <div class="text-right w-100 p-2" v-if="cart.length > 0">
          <div style="max-width: 800px" class="m-auto">
            <h4>
              <span style="color: #999">السعر الاجمالي:</span>
              {{ getCardPrice }} دينار
            </h4>
          </div>
        </div>
        <div class="card-loading" v-if="loading">
          <b-spinner variant="success" label="Spinning"></b-spinner>
        </div>

        <div class="text-center w-100 mb-2" v-if="cart.length > 0">
          <b-button
              :href="`https://wa.me/${whatsappNumber}?text=${whatsAppMessage}`"
              variant="default"
              class="mainColor-btn text-light mr-auto"
          >
            <span class="pl-2 pr-2">اطلب القائمة عبر الواتساب</span>
            <img src="images/whatsapp.svg" width="40"/>
          </b-button>
        </div>
      </b-row>
      <b-row class="change-number" v-if="getUserData">
        <!-- <b-col sm="12">

            <h4 class="text-center">بيانات العميل</h4>
          </b-col> -->
        <b-col sm="3">
          <label>الاسم</label>
        </b-col>
        <b-col sm="9" class="mb-2">
          <b-form-input
              type="text"
              disabled
              placeholder="الاسم"
              v-model="userData.name"
          ></b-form-input>
        </b-col>
        <b-col sm="3">
          <label>رقم الهاتف</label>
        </b-col>

        <b-col sm="9" class="mb-2">
          <b-form-input
              type="text"
              disabled
              placeholder="رقم الهاتف"
              v-model="userData.phone"
          ></b-form-input>
        </b-col>
        <b-col sm="3">
          <label>العنوان</label>
        </b-col>
        <b-col sm="9" class="mb-2">
          <b-form-input
              type="text"
              disabled
              placeholder="العنوان"
              v-model="userData.address"
          ></b-form-input>
        </b-col>
        <div class="d-flex w-100 pl-3">
          <b-button variant="danger" class="mr-auto" @click="removeUserData()"
          >تسجيل خروج
          </b-button
          >
          <!-- <b-button variant="primary" class="mainColor-btn mr-auto" @click="setPhone(userData)">تعديل</b-button> -->
        </div>
      </b-row>
    </b-container>
  </div>
</template>
<script type="text/javascript">
import Steps from "../global/Steps";
import SingleCartItem from "../global/SingleCartItem";
import AskForNumber from "../global/AskForNumber";
import {mapState, mapMutations, mapActions} from "vuex";
import axios from "axios";
import {getStoreConfig} from "../../config";

const storeConfig = getStoreConfig();

export default {
  name: "ShoppingCart",
  components: {Steps, SingleCartItem, AskForNumber},
  data() {
    return {
      whatsappNumber: storeConfig.whatsapp,
      num: localStorage.getItem("clientNumber"),
      showAskNumber: false,
      loading: false,
      userData: {
        name: "",
        phone: "",
        address: "",
      },
      items: [],
      data: {
        cartPhoneNumber: "",
      },
    };
  },

  computed: {
    ...mapState(["cart", "getUserData"]),
    getCardPrice() {
      let price = 0;
      for (let item of this.cart) {
        price += Number(item.selling_price);
      }
      return price;
    },
    whatsAppMessage() {
      let message = "مرحبًا, اريد طلب هذة المنتجات";
      for (let singleCart of this.cart) {
        message += ` ${singleCart.name} \n`;
      }
      return message;
    },
  },
  methods: {
    ...mapMutations(["setPhone"]),
    ...mapActions(["getCardItems", "removeUserInfo"]),
    //delete number from local storage
    removeUserData() {
      this.userData = {};
      this.removeUserInfo();
    },

    play(event) {
      this.data.cartPhoneNumber = event;
      this.getClientItems(this.data.cartPhoneNumber);
    },
    //get items
    getClientItems(number) {
      //this.loading = true;

      localStorage.setItem("clientNumber", number);
      let userData = JSON.parse(this.getUserData);
      this.num = number;
      let formData = new FormData();
      formData.append("action", "get_cart_attributes");
      formData.append("cartPhoneNumber", userData.phone);

      axios
          .post("", formData)
          .then((res) => {
            console.log(res);
            this.items = res.data.items;
            this.loading = false;
            this.num2 = "";
            window.scrollTop = 0
          })
          .catch((error) => {
            console.log(error.response);
          });
    },

    hideAsk() {
      this.showAskNumber = false;
    },
    //check client number
    checkClientNumber() {
      if (!localStorage.getItem("clientNumber")) {
        this.showAskNumber = true;
      } else if (localStorage.getItem("clientNumber")) {
        var num = localStorage.getItem("clientNumber");
        this.getClientItems(num);
      }
    },
  },
  mounted() {
    this.checkClientNumber();
    //this.getCardItems();
    if (this.getUserData) {
      if (typeof this.getUserData == "string") {
        this.userData = JSON.parse(this.getUserData);
      } else {
        this.userData = this.getUserData;
      }
    }
  },
};
</script>
